<template>
  <va-edit-layout>
    <installations-form :id="id" :title="title" :item="item"></installations-form>
  </va-edit-layout>
</template>

<script>
export default {
  props: ["id", "title", "item"],
};
</script>
